import { PLATFORM } from '@/common/js/constants.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

import {
  LANDING_TYPE,
  APP_PROMOTION_TYPE,
  DELIVERY_MODE,
  DELIVERY_TYPE,
  MARKETING_GOAL,
  AD_TYPE,
  AUDIENCE_EXTEND,
  SCHEDULE_TYPE,
  SCHEDULE_TIME_TYPE,
  BID_TYPE,
  PRICING_TYPE,
  BUDGET_MODE,
  BUDGET_OPTIMIZE_SWITCH,
  EXTERNAL_ACTION,
  DEEP_EXTERNAL_ACTION,
  DEEP_BID_TYPE,
  AMEME_TYPE,
  ANCHOR_RELATED_TYPE,
  BID_VALUE_TYPE,
  VIDEO_HP_VISIBILITY,
  BLUE_FLOW_PACKAGE_SETTING_SWITCH,
  INTELLIGENT_GENERATION_SWITCH,
  ADVANCED_DC_SETTING_ENUM,
  AUTO_EXTEND_TRAFFIC_SWITCH,
  DYNAMIC_CREATIVE_SWITCH,
  MATERIAL_STYLE,
  PROJECT_AUDIENCE_TYPE
} from '../consts/index.js'

/**
 * @description: 全局配置表单模型
 * @return {*}
 */
export const getConfigFormModel = ({ isV3 = false } = {}) => {
  return {
    isV3,
    // 保存额外辅助配置信息，用于创意组再次随机打乱分配
    recombineHelpers: {
      // 智能创意组分配表单，
      distributeForm: null
    },
    // 模板方案配置
    template: {
      adNumber: 1,
      accountAllocation: 1,
      projectAllocation: 1,
      modeAllocation: 1
    },
    accounts: [],
    project: {},
    targetings: [],
    plan: {},
    creatives: [],
    descriptions: [],
    landingPages: []
  }
}

/**
 * @description: 新建图文素材表单模型
 * @return {*}
 */
export const getCarouselFormModel = () => {
  return {
    name: '',
    images: [],
    audio: {}
  }
}

/**
 * @description: 获取项目基础表单模型
 * @return {*}
 */
export const getProjectFormModel = ({ isV3 = false } = {}) => {
  return {
    project_name: '', // 项目名称
    game: {},
    landing_type: LANDING_TYPE.APP, // 推广目的
    ch_platform_id: PLATFORM.ANDROID,
    micro_app_instance_id: '',
    app_promotion_type: APP_PROMOTION_TYPE.DOWNLOAD, // 子目的
    game_address: '', // 包下载地址
    download_url: '', // 下载链接
    subscribe_url: '', // 预约链接
    delivery_mode: DELIVERY_MODE.PROCEDURAL, // 投放模式
    delivery_type: isV3 ? DELIVERY_TYPE.NORMAL : DELIVERY_TYPE.DURATION,
    marketing_goal: MARKETING_GOAL.VIDEO_AND_IMAGE,
    blue_flow_package: {
      blue_flow_package_setting: BLUE_FLOW_PACKAGE_SETTING_SWITCH.OFF,
      blue_flow_package_id: ''
    },
    ad_type: AD_TYPE.ALL,
    app_type: '',
    micro_promotion_type: 'WECHAT_GAME', // 微信小游戏投放内容
    callback_switch: 0, // 回调开关
    media_pack_switch: 1, // 头条分包，默认参数，没有ui展示

    // 星广联投任务model
    star_task: {},
    star_task_list: [],
    star_auto_material_addition_switch: 'ON',
    audience_type: isV3 ? PROJECT_AUDIENCE_TYPE.CUSTOM : PROJECT_AUDIENCE_TYPE.UNLIMITED,

    // 搜索快投
    keywords: [],
    keywordsDesc: '', // 用于显示的文案
    search_bid_ratio: '',
    audience_extend: AUDIENCE_EXTEND.OFF,

    delivery_setting: {
      budget: '', // 项目预算
      date_range: [], // 日期区间

      bid_type: BID_TYPE.CUSTOM, // 竞价策略
      bid_type_upgrade: BID_TYPE.CUSTOM,
      schedule_type: SCHEDULE_TYPE.FROM_NOW,
      schedule_time_type: SCHEDULE_TIME_TYPE.ALL,
      schedule_time: '',
      pricing: PRICING_TYPE.PRICING_OCPM, // 付费方式
      budget_mode: BUDGET_MODE.INFINITE,

      budget_optimize_switch: BUDGET_OPTIMIZE_SWITCH.OFF, // 预算择优分配（CBO）

      bid_value_type: BID_VALUE_TYPE.FIXED, // 自动投放出价类型
      first_roi_goal: '',
      cpa_bid: '',
      bid_num_range: [],

      roi_bid_value_type: BID_VALUE_TYPE.FIXED,
      roi_goal: '',
      roi_bid_num_range: [],

      // 优化目标
      optimize_goal: {
        external_action: EXTERNAL_ACTION.PAY,
        deep_external_action: DEEP_EXTERNAL_ACTION.PURCHASE_ROI,
        deep_bid_type: DEEP_BID_TYPE.DEFAULT
      }
    }
  }
}

/**
 * @description: 获取广告基础表单模型
 * @return {*}
 */
export const getPlanFormModel = (project = {}) => {
  const isLive = project.marketing_goal === MARKETING_GOAL.LIVE
  return {
    plan_name: '', // 广告名称
    call_type: '1', // 上报媒体方式，默认参数，没有ui展示

    is_comment_disable: 'ON', // 开启评论
    ad_download_status: 'OFF', // 允许下载

    awemeIdentity: isLive ? AMEME_TYPE.DOUYIN : AMEME_TYPE.ACCOUNT, // 直播时只能选择抖音号， 其他原生广告类型，默认账号信息
    aweme_id: '', // 抖音号，达人视频选择的id
    video_hp_visibility: VIDEO_HP_VISIBILITY.ON, // 主页作品列表视频可见性
    anchor_related_type: ANCHOR_RELATED_TYPE.AUTO, // 原生锚点视频
    aweme_setting_type: 'ALL',
    original_video_title: 'ON',

    materials_type: MATERIAL_STYLE.PROMOTION_MATERIALS,

    source: '', // 来源，小游戏必填
    app_name: '', // 产品名称
    app_image: {}, // 产品主图对象：包含id、url、width、height等信息

    keywords: [], // 关键词
    blue_flow_keywords: '', // 蓝海流量关键词

    text_abstract: '',
    text_abstract_list: [], // 文本摘要信息

    selling_points: '', // 产品卖点
    selling_points_list: [],
    call_to_action_buttons: '', // 行动号召
    call_to_action_buttons_list: [],

    intelligent_generation: INTELLIGENT_GENERATION_SWITCH.ON, // 智能生成行动号召

    yuntu_category_id: [],
    cdp_brand_id: '',
    brand_name_id: '',

    dynamic_creative_switch: DYNAMIC_CREATIVE_SWITCH.OFF,
    aigc_dynamic_creative_switch: DYNAMIC_CREATIVE_SWITCH.OFF,
    advanced_dc_settings: Object.values(ADVANCED_DC_SETTING_ENUM), // 动态创意高级设置，仅搜索广告下可设置

    // auto_extend_traffic: AUTO_EXTEND_TRAFFIC_SWITCH.OFF, // 智能拓流

    bid_type: BID_VALUE_TYPE.FIXED, // 目标出价类型
    cpa_bid: '',
    budget: '',
    roi_goal: '',
    bid_num_range: [],

    roi_bid_type: BID_VALUE_TYPE.FIXED, // roi出价类型
    roi_bid_num_range: [],

    monitorPlan: []
  }
}

/**
 * @description: 获取创意表单模型
 * @return {*}
 */
export const getCreativeFormModel = () => {
  return {
    creative_name: '', // 创意组名称
    materialType: MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO], // 创意组的素材类型  4:视频 1:图片

    // 已选素材
    selectedMaterials: {
      video: [], // 视频
      image: [], // 图片
      imageAudio: [] // 图文
    }
  }
}
